/* eslint-disable no-nested-ternary */
// types
import { IChatbotType } from 'src/types/chat';

// ----------------------------------------------------------------------

export function getDefaultAiModel(models: any[], type: IChatbotType) {
  const default_model =
    models?.filter((_) => _?.type === type && _?.status?.toLowerCase() !== 'disable')?.[0] ?? null;
  const select_model = default_model?.name ? { value: default_model.name, name: undefined } : null;

  return select_model;
}

export function formatAiModel(modelName: string) {
  return modelName?.replaceAll('-', ' ') || '-';
}

// ----------------------------------------------------------------------

export function getCompanyLogo(c: string) {
  const company = c?.toLowerCase();
  return company?.includes('openai') || company?.includes('gpt')
    ? 'ri--openai-fill.svg'
    : company?.includes('anthropic') || company?.includes('claude')
    ? 'ri--anthropic-line.svg'
    : company?.includes('alibaba') || company?.includes('qwen')
    ? 'hugeicons--qwen.svg'
    : '';
}
